var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.2981 74.496C63.9391 83.7839 43.6357 78.503 27.9408 62.6988C12.246 46.8946 7.11274 26.5475 16.4717 17.2596C25.8307 7.97171 46.134 13.2525 61.8289 29.0568C77.5184 44.861 82.657 65.208 73.2981 74.496Z",
    fill: "url(#paint0_linear_502_8421)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8446 74.9497C63.4856 84.2376 43.1824 78.9568 27.4875 63.1526C11.798 47.3483 6.65935 27.0013 16.0183 17.7134C25.3773 8.42545 45.6806 13.7063 61.3755 29.5105C77.0704 45.3147 82.2036 65.6618 72.8446 74.9497Z",
    fill: "url(#paint1_linear_502_8421)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6144 75.1793C63.1297 84.5929 42.7225 79.416 27.0331 63.6063C11.3437 47.8021 6.30886 27.3566 15.7936 17.943C25.2783 8.52931 45.6855 13.7063 61.3804 29.516C77.0753 45.3202 82.1046 65.7656 72.6199 75.1847L72.6144 75.1793Z",
    fill: "url(#paint2_linear_502_8421)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1558 75.633C62.6711 85.0466 42.2639 79.8697 26.569 64.06C10.8742 48.2558 5.84478 27.8103 15.3295 18.3912C24.8142 8.97756 45.2214 14.1545 60.9108 29.9642C76.6002 45.7684 81.6351 66.2139 72.1503 75.633H72.1558Z",
    fill: "url(#paint3_linear_502_8421)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6966 76.0869C62.2118 85.5005 41.8047 80.3235 26.1098 64.5139C10.4203 48.7096 5.38552 28.2642 14.8702 18.8451C24.355 9.43141 44.7621 14.6084 60.457 30.4181C76.1465 46.2223 81.1813 66.6677 71.6966 76.0869Z",
    fill: "url(#paint4_linear_502_8421)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2429 76.5405C61.7582 85.9541 41.351 80.7772 25.6562 64.9675C9.96673 49.1633 4.9319 28.7178 14.4166 19.3042C23.9013 9.89052 44.3085 15.0675 60.0034 30.8772C75.6983 46.6814 80.7277 67.1268 71.2484 76.546L71.2429 76.5405Z",
    fill: "url(#paint5_linear_502_8421)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7837 76.9996C61.299 86.4132 40.8919 81.2363 25.197 65.4266C9.50209 49.6223 4.47271 29.1769 13.9574 19.7578C23.4422 10.3441 43.8494 15.5211 59.5388 31.3308C75.2337 47.135 80.263 67.5804 70.7783 76.9996H70.7837Z",
    fill: "url(#paint6_linear_502_8421)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3245 77.4535C60.8398 86.8671 40.4326 81.6901 24.7377 65.8805C9.04827 50.0762 4.01345 29.6308 13.4982 20.2171C22.9829 10.8035 43.3901 15.9804 59.085 31.7901C74.7744 47.5944 79.8092 68.0398 70.3245 77.4589V77.4535Z",
    fill: "url(#paint7_linear_502_8421)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8648 77.9072C60.3801 87.3208 39.9729 82.1439 24.278 66.3342C8.58315 50.5299 3.55377 30.0845 13.0385 20.6654C22.5232 11.2517 42.9304 16.4287 58.6253 32.2384C74.3147 48.0426 79.3495 68.488 69.8648 77.9072Z",
    fill: "url(#paint8_linear_502_8421)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4058 78.3609C59.9211 87.7746 39.5139 82.5976 23.819 66.7879C8.12415 50.9837 3.09479 30.5382 12.5795 21.1191C22.0642 11.7055 42.4714 16.8824 58.1608 32.6921C73.8557 48.4963 78.8851 68.9418 69.4004 78.3609H69.4058Z",
    fill: "url(#paint9_linear_502_8421)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9519 78.8146C59.4672 88.2283 39.06 83.0513 23.3651 67.2416C7.6757 51.4374 2.64089 30.992 12.1256 21.5728C21.6103 12.1592 42.0175 17.3362 57.7124 33.1458C73.4018 48.9501 78.4366 69.3955 68.9519 78.8092V78.8146Z",
    fill: "url(#paint10_linear_502_8421)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7653 74.0596C83.1224 64.7708 77.9877 44.427 62.2965 28.6203C46.6053 12.8137 26.2997 7.52998 16.9426 16.8188C7.58544 26.1075 12.7202 46.4514 28.4114 62.258C44.1025 78.0646 64.4082 83.3483 73.7653 74.0596Z",
    fill: "#0C0232"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9199 70.1772C61.8291 78.2133 44.2646 73.6431 30.6908 59.9709C17.117 46.3042 12.6781 28.7069 20.7688 20.6708C28.8595 12.6348 46.424 17.2049 59.9978 30.8771C73.5716 44.5494 78.0106 62.1412 69.9199 70.1772Z",
    fill: "#040404"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9199 70.1772C61.8291 78.2133 44.2646 73.6431 30.6908 59.9709C17.117 46.3042 12.6781 28.7069 20.7688 20.6708C28.8595 12.6348 46.424 17.2049 59.9978 30.8771C73.5716 44.5494 78.0106 62.1412 69.9199 70.1772Z",
    fill: "url(#paint11_linear_502_8421)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9916 73.2713C63.8896 82.3078 44.1329 77.1691 28.8644 61.7913C13.596 46.4135 8.59941 26.6185 17.7015 17.5821C26.8035 8.54564 46.5602 13.6843 61.8287 29.0622C77.0971 44.44 82.0937 64.2349 72.9916 73.2713ZM30.6958 59.9709C44.2696 73.6431 61.8287 78.2078 69.9248 70.1772C78.0155 62.1411 73.5766 44.5493 60.0028 30.8771C46.429 17.2049 28.8699 12.6402 20.7737 20.6708C12.683 28.7068 17.122 46.2987 30.6958 59.9709Z",
    fill: "url(#paint12_linear_502_8421)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1331 51.3367L49.215 59.7305C49.2028 59.7549 49.1906 59.7794 49.1731 59.7912C49.1532 59.8079 49.1357 59.8198 49.1143 59.8277C49.0891 59.8319 49.0702 59.8349 49.0498 59.8293C49.0295 59.8236 49.0091 59.8179 48.9898 59.7986L43.3416 55.3016C43.3416 55.3016 43.3068 55.2668 43.2938 55.2464C43.2807 55.2261 43.2726 55.196 43.2659 55.1746C43.2578 55.1445 43.2598 55.1171 43.2618 55.0899C43.2639 55.0626 43.2722 55.0343 43.2844 55.0098L45.423 50.4242C45.4743 50.3215 45.4936 50.2015 45.4926 50.0758C45.4892 49.955 45.4566 49.8345 45.4041 49.7307L39.2584 38.232C39.2035 38.1331 39.1734 38.0076 39.1699 37.8868C39.1665 37.7661 39.1921 37.6451 39.2395 37.5385L43.1674 29.1252C43.1918 29.0762 43.2254 29.0438 43.2657 29.0328C43.3084 29.0168 43.3515 29.0233 43.3888 29.0532L49.037 33.5502C49.037 33.5502 49.0718 33.585 49.0848 33.6053C49.0978 33.6257 49.106 33.6558 49.1165 33.6811C49.1208 33.7073 49.1226 33.7385 49.1206 33.7658C49.1186 33.7931 49.1102 33.8214 49.098 33.8459L46.9496 38.451C46.8984 38.5537 46.8766 38.6786 46.88 38.7994C46.881 38.9251 46.9136 39.0456 46.9685 39.1445L53.1142 50.6432C53.1667 50.747 53.1993 50.8676 53.2027 50.9883C53.2062 51.1091 53.1805 51.2301 53.1331 51.3367Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0643 36.2037L50.2653 40.051C50.2311 40.1195 50.2212 40.1975 50.2214 40.2783C50.2216 40.3592 50.247 40.436 50.2773 40.503L54.3453 48.142C54.3597 48.1711 54.3829 48.1943 54.4047 48.2088C54.4303 48.2271 54.457 48.2317 54.4836 48.2364C54.5127 48.2361 54.5365 48.2233 54.5603 48.2104C54.5866 48.1927 54.6051 48.1672 54.6197 48.1378L57.9911 40.9205C57.9911 40.9205 58.0092 40.8726 58.0137 40.8405C58.0157 40.8132 58.0178 40.7859 58.0096 40.7558C58.0053 40.7295 57.9947 40.7042 57.9817 40.6839C57.9687 40.6635 57.9518 40.6393 57.9339 40.6287L52.2896 36.1356C52.2896 36.1356 52.2499 36.1106 52.2295 36.1049C52.2092 36.0993 52.1864 36.0985 52.165 36.1064C52.1437 36.1144 52.1262 36.1262 52.1062 36.143C52.0863 36.1597 52.0766 36.1793 52.0643 36.2037Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3203 52.6471L42.1193 48.7998C42.1535 48.7313 42.1635 48.6533 42.1594 48.5686C42.1592 48.4877 42.1338 48.411 42.1035 48.344L38.0306 40.7147C38.0162 40.6856 37.993 40.6624 37.9687 40.6528C37.9431 40.6345 37.9165 40.6299 37.8912 40.634C37.8621 40.6342 37.8383 40.6471 37.8145 40.66C37.7883 40.6777 37.7698 40.7032 37.7551 40.7325L34.3911 47.9352C34.3911 47.9352 34.3691 47.9792 34.3685 48.0152C34.3665 48.0425 34.3645 48.0698 34.3726 48.1C34.3769 48.1262 34.3874 48.1515 34.398 48.1767C34.411 48.1971 34.4279 48.2213 34.4458 48.2319L40.094 52.7288C40.1313 52.7587 40.1783 52.769 40.2186 52.758C40.2613 52.7421 40.2987 52.7135 40.3193 52.6607L40.3203 52.6471Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1326 51.3366L49.2145 59.7303C49.2023 59.7548 49.1901 59.7792 49.1726 59.7911C49.1527 59.8078 49.1352 59.8196 49.1138 59.8276C49.0886 59.8317 49.0696 59.8348 49.0493 59.8291C49.029 59.8234 49.0086 59.8177 48.9893 59.7984L43.3411 55.3014C43.3411 55.3014 43.3063 55.2666 43.2932 55.2463C43.2802 55.2259 43.2721 55.1958 43.2654 55.1744C43.2572 55.1443 43.2593 55.117 43.2613 55.0897C43.2633 55.0624 43.2717 55.0341 43.2839 55.0096L45.4225 50.424C45.4738 50.3213 45.4931 50.2013 45.4921 50.0757C45.4887 49.9549 45.4561 49.8343 45.4036 49.7305L39.2579 38.2318C39.203 38.1329 39.1729 38.0075 39.1694 37.8867C39.166 37.7659 39.1916 37.6449 39.239 37.5383L43.1669 29.125C43.1913 29.0761 43.2249 29.0437 43.2652 29.0326C43.3079 29.0167 43.351 29.0232 43.3883 29.0531L49.0365 33.55C49.0365 33.55 49.0713 33.5848 49.0843 33.6052C49.0973 33.6255 49.1055 33.6557 49.116 33.6809C49.1203 33.7072 49.1221 33.7383 49.1201 33.7656C49.118 33.7929 49.1097 33.8212 49.0975 33.8457L46.9491 38.4509C46.8979 38.5536 46.8761 38.6785 46.8795 38.7992C46.8805 38.9249 46.9131 39.0455 46.968 39.1444L53.1137 50.6431C53.1662 50.7469 53.1987 50.8674 53.2022 50.9882C53.2057 51.109 53.18 51.23 53.1326 51.3366Z",
    fill: "url(#paint13_linear_502_8421)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.064 36.2036L50.265 40.0509C50.2308 40.1194 50.2209 40.1974 50.2211 40.2782C50.2213 40.3591 50.2467 40.4359 50.277 40.5029L54.345 48.1419C54.3594 48.171 54.3826 48.1942 54.4044 48.2086C54.43 48.2269 54.4567 48.2316 54.4833 48.2363C54.5124 48.236 54.5362 48.2232 54.56 48.2103C54.5863 48.1926 54.6048 48.1671 54.6195 48.1377L57.9908 40.9204C57.9908 40.9204 58.0089 40.8725 58.0134 40.8403C58.0154 40.8131 58.0175 40.7858 58.0093 40.7556C58.005 40.7294 57.9945 40.7041 57.9814 40.6838C57.9684 40.6634 57.9515 40.6392 57.9336 40.6286L52.2893 36.1355C52.2893 36.1355 52.2496 36.1105 52.2292 36.1048C52.2089 36.0991 52.1861 36.0984 52.1648 36.1063C52.1434 36.1143 52.1259 36.1261 52.1059 36.1429C52.086 36.1596 52.0763 36.1792 52.064 36.2036Z",
    fill: "url(#paint14_linear_502_8421)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3198 52.6468L42.1188 48.7995C42.153 48.7311 42.163 48.6531 42.1589 48.5683C42.1587 48.4875 42.1333 48.4107 42.103 48.3437L38.0301 40.7144C38.0157 40.6853 37.9925 40.6621 37.9683 40.6526C37.9426 40.6343 37.916 40.6296 37.8907 40.6337C37.8617 40.634 37.8379 40.6468 37.814 40.6597C37.7878 40.6775 37.7693 40.7029 37.7546 40.7323L34.3906 47.9349C34.3906 47.9349 34.3686 47.9789 34.368 48.015C34.366 48.0423 34.364 48.0696 34.3721 48.0997C34.3764 48.126 34.3869 48.1512 34.3975 48.1765C34.4105 48.1968 34.4274 48.221 34.4453 48.2316L40.0936 52.7286C40.1308 52.7585 40.1778 52.7688 40.2181 52.7578C40.2608 52.7418 40.2982 52.7133 40.3188 52.6605L40.3198 52.6468Z",
    fill: "url(#paint15_linear_502_8421)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_8421",
    x1: 15.4549,
    y1: 17.7954,
    x2: 75.7034,
    y2: 75.2777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_8421",
    x1: 15.007,
    y1: 18.2655,
    x2: 75.2555,
    y2: 75.7423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_8421",
    x1: 14.7877,
    y1: 18.4951,
    x2: 75.0307,
    y2: 75.9774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_502_8421",
    x1: 14.34,
    y1: 18.9652,
    x2: 74.5885,
    y2: 76.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_502_8421",
    x1: 13.8972,
    y1: 19.43,
    x2: 74.1402,
    y2: 76.9069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_502_8421",
    x1: 13.449,
    y1: 19.9,
    x2: 73.6975,
    y2: 77.3769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_502_8421",
    x1: 13.0062,
    y1: 20.3646,
    x2: 73.2547,
    y2: 77.8415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_502_8421",
    x1: 12.5579,
    y1: 20.8294,
    x2: 72.8064,
    y2: 78.3117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_502_8421",
    x1: 12.1146,
    y1: 21.2995,
    x2: 72.3631,
    y2: 78.7764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_502_8421",
    x1: 11.672,
    y1: 21.7642,
    x2: 71.915,
    y2: 79.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#173089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_502_8421",
    x1: 11.2236,
    y1: 22.2289,
    x2: 71.4721,
    y2: 79.7112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_502_8421",
    x1: 51,
    y1: 17,
    x2: 42,
    y2: 71.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A2484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_502_8421",
    x1: 88.4351,
    y1: 2.64161,
    x2: 13.0329,
    y2: 77.5026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D189F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9222FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF0CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_502_8421",
    x1: 34.3711,
    y1: 44.4282,
    x2: 58.0103,
    y2: 44.4282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_502_8421",
    x1: 34.3711,
    y1: 44.4282,
    x2: 58.0103,
    y2: 44.4282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_502_8421",
    x1: 34.3711,
    y1: 44.4282,
    x2: 58.0103,
    y2: 44.4282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF536D",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin3);
export default __webpack_public_path__ + "static/media/coin3.9dd755e2.svg";
export { ForwardRef as ReactComponent };